/**
 * Ready-to-post Morfi demo clips for the Rewards "Clips" modal — the
 * human-edited half of the manifest (titles + captions). The video/poster URLs
 * live in {@link ./clips.assets.generated.json}, keyed by `slug`, and are
 * produced by `pnpm clips:sync` (uploads to Vercel Blob). The two are merged by
 * slug in {@link ./clips-button.tsx}.
 *
 * Mirrors the content library's `DEMO_VIDEOS` set (the same clips behind
 * content.morfi.markets). Each caption @mentions @morfimarkets and ends with a
 * sign-up CTA carrying the participant's referral link via the `{{link}}` token,
 * substituted at render time. Verbatim marketing copy → kept as data, not i18n.
 *
 * To add a clip: append an entry here, drop `<slug>.mp4` (+ optional
 * `<slug>.jpg`) in `clips-source/rewards/`, then run `pnpm clips:sync`.
 */
export interface RewardsClipContent {
  id: string;
  /** Matches the source filename in `clips-source/rewards/` and the manifest key. */
  slug: string;
  title: string;
  /** `{{link}}` → the participant's referral link at render time. */
  caption: string;
}

export const REWARDS_CLIP_CONTENT: readonly RewardsClipContent[] = [
  {
    id: 'market-feed',
    slug: 'market-feed',
    title: 'Scroll the markets',
    caption:
      'scrolling @morfimarkets is dangerous.\n\nGOAT debates, vim vs emacs, which AI lab owns the next decade. every market live, the crowd picking sides tick by tick.\n\ncome see for yourself: {{link}}',
  },
  {
    id: 'market-buy',
    slug: 'market-buy',
    title: 'Trade in seconds',
    caption:
      'the trading UX on @morfimarkets is first-in-class, full stop.\n\npick a side, size it, tap trade. your position is live in seconds, smoothest flow in crypto right now.\n\ntry it: {{link}}',
  },
];
